import { createSelector } from '@reduxjs/toolkit'

import { getLogs } from '../root.selectors'

export const getLogLookups = createSelector(getLogs, (logsSlice) => logsSlice.lookups)
export const getLogsEntries = createSelector(getLogs, (logsSlice) => logsSlice.entries)
